import axios from "@/utils/axios";
import { Guid } from "@/domain/guid";
import { SearchCharacterResponse } from "@/api/characters/search-character.response";
import { GetOneCharacterWishesResponse } from "@/api/characters/get-one-character-wishes.response";
import { SaveOneCharacterWishesRequest } from "@/api/characters/save-one-character-wishes.request";
import { GetOneCharacterResponse } from "@/api/characters/get-one-character.response";


export default {
	async fetchCharacter(characterID: Guid): Promise<GetOneCharacterResponse> {
		return (await axios().get(`/characters/${characterID}`)).data;
	},
	async fetchWishes(characterID: Guid): Promise<GetOneCharacterWishesResponse> {
		return (await axios().get(`/characters/${characterID}/wishes/`)).data;
	},
	async shareWishlistWithTeam(characterID: Guid, payload: any): Promise<void> {
		return (await axios().patch(`/characters/${characterID}/wishes/share`, payload)).data;
	},
	async saveWishes(characterID: Guid, wishes: SaveOneCharacterWishesRequest): Promise<void> {
		return (await axios().patch(`/characters/${characterID}/wishes/`, wishes)).data;
	},
	async searchCharacter(region: string, realm: string, name: string): Promise<SearchCharacterResponse> {
		return (await axios().get(`/characters/${region}/${realm}/${name}`)).data;
	}
};